import { LinkGroupMemberReq, PreviewGroupMemberLinkReq, UnlinkGroupMemberReq, UpdateGroupMemberBulkReq, UpdateGroupMemberPropertyVisibleReq, UpdateGroupMemberStatusReq, UpdateReorderListReq } from '../dto/ReqDtoRepository';
import { GroupMemberLinkPreviewResponse, GroupMemberListResponse, GroupMemberPropertyVisibleResponse, GroupMemberResponse, SimpleStringResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getGroupMemberList = async (aui: string): Promise<GroupMemberListResponse> => {
  return sendGetApiRequest<GroupMemberListResponse>(`/api/v1/group-member/list?aui=${encodeURIComponent(aui)}`);
};

export const getGroupMemberListOwner = async (aui: string): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>('get', `/api/v1/group-member/list/owner?aui=${encodeURIComponent(aui)}`);
};

export const createGroupMember = async (aui: string): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>('post', `/api/v1/group-member?aui=${encodeURIComponent(aui)}`);
};

export const updateGroupMemberBulk = async (
  aui: string,
  data: UpdateGroupMemberBulkReq,
): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>(
    'put',
    `/api/v1/group-member/bulk?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const linkGroupMember = async (aui: string, data: LinkGroupMemberReq): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>('put', `/api/v1/group-member/link/confirm?aui=${encodeURIComponent(aui)}`, data);
};

export const previewGroupMemberLink = async (
  aui: string,
  data: PreviewGroupMemberLinkReq,
): Promise<GroupMemberLinkPreviewResponse> => {
  return sendApiRequest<GroupMemberLinkPreviewResponse>(
    'post',
    `/api/v1/group-member/link/preview?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const unlinkGroupMember = async (
  aui: string,
  data: UnlinkGroupMemberReq,
): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>(
    'put',
    `/api/v1/group-member/unlink?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const updateGroupMemberStatus = async (aui: string, data: UpdateGroupMemberStatusReq): Promise<GroupMemberResponse> => {
  return sendApiRequest<GroupMemberResponse>('put', `/api/v1/group-member/status?aui=${encodeURIComponent(aui)}`, data);
};

export const updateGroupMemberPropertyVisible = async (
  aui: string,
  data: UpdateGroupMemberPropertyVisibleReq,
): Promise<GroupMemberPropertyVisibleResponse> => {
  return sendApiRequest<GroupMemberPropertyVisibleResponse>(
    'put',
    `/api/v1/group-member/property-visible?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const reorderGroupMembers = async (
  aui: string,
  data: UpdateReorderListReq,
): Promise<GroupMemberListResponse> => {
  return sendApiRequest<GroupMemberListResponse>(
    'put',
    `/api/v1/group-member/reorder?aui=${encodeURIComponent(aui)}`,
    data,
  );
};

export const deleteGroupMember = async (aui: string, groupMemberId: string): Promise<SimpleStringResponse> => {
  return sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/group-member?aui=${encodeURIComponent(aui)}&groupMemberId=${encodeURIComponent(String(groupMemberId))}`
  );
};
